import { defineStyle as r, defineStyleConfig as e } from "@chakra-ui/react";
const a = r({
  isolation: "isolate",
  "--border-width": "1px",
  position: "relative",
  borderRadius: "var(--chakra-radii-full)",
  border: "var(--border-width) solid transparent",
  _before: {
    content: "''",
    position: "absolute",
    inset: "calc(var(--border-width) * -1)",
    animation: "spin 3s linear infinite",
    animationPlayState: "running",
    borderRadius: "inherit",
    border: "inherit",
    backgroundImage: "conic-gradient(from var(--angle), transparent 80%, var(--chakra-colors-secondary-500) 90%, transparent 100%)",
    backgroundOrigin: "border-box",
    zIndex: -1,
    maskImage: "linear-gradient(black, black), linear-gradient(black, black)",
    maskClip: "content-box, border-box",
    maskComposite: "exclude",
    "@keyframes spin": {
      to: { "--angle": "1turn" }
    }
  }
}), i = e({
  baseStyle: a
});
export {
  i as MagicButtonTheme
};
//# sourceMappingURL=MagicButton.es.js.map
